import Styled from 'styled-components';
import { respondTo } from "@/respondTo";  


export const OverviewContainer= Styled.div `
    width: 100%;
    height: 100%;


    ${respondTo.tablet_landscape_s`
        display: flex;
        padding:2.5rem;
        border-bottom: 1px solid #DEE3EB;   
    `}

    ${respondTo.desktop_xl`
        padding:2.5rem 4.375rem 3.75rem  ;
    `}
    `
export const ContainerLarge = Styled.div`
  ${respondTo.tablet_landscape_s`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: flex-start;
    position: relative;
    `
    }



`
export const ImageContainer = Styled.div`
    ${respondTo.tablet_landscape_s`
        width: 25.31rem;
        height: 100%;
    `}

    ${respondTo.desktop_xl`
     
       
    `}
`

export const TextContainer = Styled.div`
    padding:1.25rem 0 2.5rem;

    ${respondTo.tablet_landscape_s`
        padding: 0 0 2.5rem 1.25rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: calc(100% - 23.31rem);
    `}
   
    ${respondTo.desktop`
        padding: 0 0 2.5rem 1.25rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: calc(100% - 25.31rem);
    `}

    ${respondTo.desktop_xl`
        padding: 0 0 2.5rem 2.5rem;
    `}
`

export const ItemSelectors = Styled.div`

    ${respondTo.tablet_landscape_s`
        display: flex;
        width: 100%;
        padding: 0 0 1.25rem 0;  
    `}

 
`
export const TitleSmall = Styled.div`
    padding: 2.5rem 1.25rem 0.625rem;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    ${respondTo.tablet_landscape_s`
        display: none;
    `}
`
export const TitleLarge = Styled.div`
    display: none;
    ${respondTo.tablet_landscape_s`
        display: block;
        margin: 0 0 3.75rem;
    `}
`
export const Selector = Styled.h6<{active: boolean}>`

    color: ${props => props.active ? "var(--primary-light)" : "var(--disabled)"} ;
    display: block;
    padding-top: 1.25rem;
    margin-bottom: 0.5rem;
    cursor: pointer;
    :after {
        content: "";
        display: block;
        width: 0;
        height: 2px;
        background: var(--primary-light);
        transition: width 0.2s;

        ${props => props.active && `
            width: 100%;
        `}
    }
    ${respondTo.tablet_landscape_s`
        padding-bottom: 1.25rem;
    `}
  
    
`;
export const SelectedBox = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0.625rem 1.25rem 0.625rem;
    
    ${respondTo.tablet_landscape_s`
        display: block;
        margin: 0;
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2; 
        
       
    `}
    `;

export const btnSx = {
    alignItems: "center",
    backgroundColor: "var(--primary-light)",
    color:  "var(--on-primary-light)",
    marginLeft: "auto",
    marginTop:" 1.875rem",
} 

